exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.metadata .dropdown-toggle {\n  border-radius: 0px !important;\n}\n.metadata .dropdown-toggle .selected-tag {\n  background-color: #fff;\n  border-color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ecd050a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/mystique/users/Form.vue
// module id = 858
// module chunks = 1